'use strict';

angular.module('rmOBA.01PostingDetails', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/', {
        templateUrl: 'views/01PostingDetails/01PostingDetails.html'
    });
}])

/**
* @memberof rmOBA
* @ngdoc controller
* @name 01PostingDetailsControl
* @param $scope {service} controller scope
* @param $location {service} Angular location service
* @param $alert {service} Angular Strap alert directive - Alerts are styled tiny dialogs that inherit the behavior of modals.
* @param $cookies {service} Angular cookies service
* @param rmUtils {service} General utilites used in this app
* @param rmState {service} State service for this app - Particularly navigation states
* @param rmResources {service} Resources service - group and individual functions to gather form data from converted json files
* @param rmUserLocationData {service} Gather user location data from local storage
* @description 
*   The initial view for the app. This view contains the location form as 
*   the first stage of completing the emergency order form process.
*/
.controller('01PostingDetailsCtrl', [ 
    '$scope', 
    '$location',
    '$alert',
    '$cookies',
    'rmUtils', 
    'rmState', 
    'rmResources', 
    'rmUserLocationData', function ( 
        $scope, 
        $location, 
        $alert,
        $cookies,
        rmUtils, 
        rmState, 
        rmResources, 
        rmUserLocationData
    ) {
    var _this = this;

    // store data before pushing to master
    // if there is local storage use this to populate form
    $scope.user = {};
    $scope.formHasContent = false;
    
    var storedUserData = rmUserLocationData.get();
    // var storedUserData = rmUserLocationData.dummyStorage; // Use dummy storage data

    if (!_.isEmpty(storedUserData)) {
        $scope.user = storedUserData;
        $scope.formHasContent = true;
    }

    // Get the data for the fields needed for the Location form
    rmResources.getLocationFormData().then(function(data) {
        $scope.formData = data.data;

        angular.forEach($scope.formData, function (value, key) {
            // Set the regex pattern to validate this field
            if (value['Validation'].length > 0) {
                value.regex = rmUtils.getRegex(value['Validation']);
            }

            // camelCase the Field value so it can be used as an ID
            var fieldName = rmUtils.camelize(value["Field"]);

            // set this as a value in the model
            value['FieldName'] = fieldName;
            
            if (typeof storedUserData !== 'object') {
                $scope.user[value.FieldName] = null;
            }
            value.value = null;
        });
    });

    /**
    * @memberof 01PostingDetailsControl
    * @function reset
    * @desc Reset the form
    * @param {object} form the form parent
    */
    $scope.reset = function(form) {
        // reset form controls
        if (form) {
            form.$setPristine();
            form.$setUntouched();
        } else {
            return;
        }
        $scope.formHasContent = false;
        // reset user data.
        $scope.user = angular.copy({});
        
        // prevent movement past this section.
            // update the navigation.
        rmState.set('stage1Passed', false)
        rmState.set('stage2Passed', false) 

        // clear all form inputs        
        var inputs = document.getElementsByTagName('input');
        for (var i = inputs.length - 1; i >= 0; i--) {
            inputs[i].value = '';
        }
        var textareas = document.getElementsByTagName('textarea');
        for (var i = textareas.length - 1; i >= 0; i--) {
            textareas[i].value = '';
        }
        
    };

   
    /**
    * @memberof 01PostingDetailsControl
    * @function submit
    * @desc Submit the form
    * @param {object} form the form parent
    */
    $scope.submit = function(form) {

        // Submit the form if there is nothing in local storage or the form hasn't been interacted with.
        // Forms in both cases must be valid
        if (typeof storedUserData === 'object' && form.$valid || form.$touched && form.$valid) {
            // Push the data to local storage
            rmUserLocationData.put($scope.user);
            rmState.set('stage1Passed', true) // update the navigation.
            $location.path('/02-order-details');
        }

        if (!form.$valid) {
            alert('form invalid');
        }
    }


    window.postingDetails = $scope;
}]);